module.exports = __webpack_public_path__ + "static/media/S3_01.487d93e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/STAGE3strobe/S3_01.png
// module id = 195
// module chunks = 0